import { Solution } from '@energiebespaarders/constants';

export const expressSolutions: Solution[] = [
  Solution.PvSystem,
  Solution.FloorInsulation,
  Solution.AirToAirHeatPump,
  Solution.ElectricHeatPump,
  Solution.HybridHeatPump,
  Solution.InnerRoofInsulation,
  Solution.HomeBattery,
  Solution.WallInsulation,
  Solution.WindowGlazing,
  Solution.CentralHeatingBoiler,
];

export const fastLaneSlugs: Record<Solution, string> = {
  [Solution.PvSystem]: 'zonnepanelen',
  [Solution.FloorInsulation]: 'vloerisolatie',
  [Solution.CrawlspaceInsulation]: 'vloerisolatie',
  [Solution.WallInsulation]: 'spouwmuurisolatie',
  [Solution.InnerRoofInsulation]: 'dakisolatie',
  [Solution.AtticFloorInsulation]: 'zoldervloerisolatie',
  [Solution.AirToAirHeatPump]: 'airco',
  [Solution.ElectricHeatPump]: 'warmtepomp',
  [Solution.HybridHeatPump]: 'hybride-warmtepomp',
  [Solution.WindowGlazing]: 'isolatieglas',
  [Solution.WindowFrames]: 'kozijnen',
  [Solution.CentralHeatingBoiler]: 'cv-ketel',
  [Solution.UnderfloorHeating]: 'vloerverwarming',
  [Solution.ChargingBox]: 'laadpaal',
  [Solution.HomeBattery]: 'thuisbatterij',
  [Solution.Sedum]: 'sedum',
  [Solution.Miscellaneous]: 'overig',
};
